// Frontend environment configuration service
// Maps environment-specific variables to standard configuration

interface AppConfig {
  apiUrl: string;
  environment: string;
  debug: boolean;
  aws: {
    region: string;
    frontendBucket: string;
  };
}

// Validate required environment variables
const validateConfig = (config: AppConfig): void => {
  const requiredVars = {
    'REACT_APP_API_URL': config.apiUrl,
    'REACT_APP_AWS_REGION': config.aws.region,
    'REACT_APP_S3_BUCKET': config.aws.frontendBucket
  };

  const missingVars = Object.entries(requiredVars)
    .filter(([_, value]) => !value || value === 'NOT_SET')
    .map(([key]) => key);

  if (missingVars.length > 0) {
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }
};

// Load configuration from environment variables
const loadConfig = (): AppConfig => {
  const config: AppConfig = {
    apiUrl: process.env.REACT_APP_API_URL || '',
    environment: process.env.NODE_ENV || 'development',
    debug: process.env.NODE_ENV === 'development',
    aws: {
      region: process.env.REACT_APP_AWS_REGION || '',
      frontendBucket: process.env.REACT_APP_S3_BUCKET || '',
    },
  };
  
  // Validate configuration
  validateConfig(config);
  
  // Only log in development mode
  if (config.debug) {
    console.log(`[Config] Environment: ${config.environment}`);
    console.log(`[Config] API URL: ${config.apiUrl}`);
    console.log(`[Config] AWS Region: ${config.aws.region}`);
  }
  
  return config;
};

// Export the configuration
export const config = loadConfig();

// Export individual config sections for convenience
export const {
  apiUrl,
  environment,
  debug,
  aws,
} = config; 